module.exports = __webpack_public_path__ + "img/overworked-employee.d1c20a0f.svg";